import { useEffect, useState } from "preact/hooks";
export function debounce(func, delay = 80) {
    let timeoutId;
    return (...args) => {
        const later = () => {
            timeoutId = undefined;
            func(...args);
        };
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(later, delay);
    };
}
export function onNextAnimationFrame(run) {
    let token = null;
    return (...args) => {
        if (!token) {
            token = window.requestAnimationFrame(() => {
                run(...args);
                token = null;
            });
        }
    };
}
export function inNextFrame(callback) {
    window.requestAnimationFrame(() => window.requestAnimationFrame(callback));
}
export function useDebounced(value, delay, onSetCallback) {
    const [debouncedValue, setDebouncedValue] = useState(value);
    useEffect(() => {
        const timer = window.setTimeout(() => {
            setDebouncedValue(value);
            if (onSetCallback) {
                onSetCallback();
            }
        }, delay);
        return () => window.clearTimeout(timer);
    }, [value]);
    return debouncedValue;
}
